module.exports = __webpack_public_path__ + "static/media/incident_category-weather.de4c0a54.svg";